import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import { Button, Header, Columns, Container } from '../../elements'
import GetUserReferralInfo from '../calls/getUserReferralInfo.js'
import Skeleton from '../../elements/skeletons/TempSkeleton.js'
import UserInviteScreen from './referralsInviteLayout.js'
import './../referrals.css'
import { apiProcess } from '../../../components/api/api'

class ReferralsPage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      referral_data: {
        concession_days: null,
        trip_duration_days: null,
        concession_discount_rate: null
      }
    }
  }

  componentDidMount() {
    const apiURL = 'referrals/info'
    apiProcess(
      apiURL,
      false,
      'get-referral-info',
      'Get a referral information'
    )
    .then((responseData) => {
      this.setState({
        referral_data: responseData.referral_data
      })
    })
    .catch((error) => {
      let message =
        'Oops. Something went wrong. If you continue to experience issues, please contact us at info@twistedroad.com'
      if (error.errorResponseData.errors) {
        message = error.errorResponseData.errors[0]
      }
      console.log('referral fetch error', error)
    })
  }
  render() {
    const { referral_data } = this.state
    return (
      <React.Fragment>
        {!this.props.auth.state.isAuth && (
          <div className="referrals-invite-wrap">
            <div className="ref-invite-top">
              <Container className="small mt-0" style={{ paddingTop: '7rem' }}>
                <Columns>
                  <Columns.Column className="has-text-centered ref-invite-header">
                    <span
                      className="referrals-eyebrow"
                      style={{
                        fontSize: '1.2rem',
                        marginTop: '0',
                        color: '#fff',
                        display: 'block',
                        textTransform: 'uppercase',
                        fontWeight: '800',
                      }}
                    >
                      Want more friends with benefits?
                    </span>
                    <div className="ref-description">
                      Invite your friends to give them a Free Day of riding.
                      When they take their first trip or <a href="/list-your-motorcycle"><strong>list their first
                      motorcycle</strong></a>, you’ll get $25 in your account.
                    </div>
                    <div className="referrals-header">
                      Give a Free Day, Get $25 Dollars
                    </div>
                  </Columns.Column>
                </Columns>
                <div className="has-text-centered">
                  <Button
                    color="primary"
                    size="large"
                    onClick={() => this.props.auth.openLogin()}
                    className="mb-4"
                  >
                    Login To Start Inviting Friends
                  </Button>
                  <br />
                  <a
                    className="button is-small is-white"
                    href="/referrals/redeem"
                    size="small"
                    color="white"
                  >
                    Redeem a Referral
                  </a>
                </div>
              </Container>
            </div>
            <div className="ref-invite-more-info">
              <Columns className='refer-wrapper'>
                <Columns.Column size={6} className="content">
                  <Header
                    renderas="h2"
                    size={5}
                    className="has-text-weight-extra-bold mt-3"
                  >
                    Refer a Rider
                  </Header>

                  <p className='has-text-centered'>
                    You'll get $25 and you'll be hooking up your friend with a
                    massive discount on their first ride:
                  </p>

                  <p className="has-text-centered">
                      {referral_data.concession_days} free day of riding when
                    <br />
                    they book for {referral_data.trip_duration_days} or more days
                  </p>
                  <div className="divider">OR</div>
                  <p className="has-text-centered">
                    {referral_data.concession_discount_rate * 100}% if they book for less than {referral_data.trip_duration_days} days.{' '}
                  </p>
                </Columns.Column>
              </Columns>
            </div>
          </div>
        )}

        {this.props.auth.state.isAuth && (
          <GetUserReferralInfo
            referralDescription={'Get Referral Info from main invite page.'}
            render={({
              refLoading,
              getRefInfo,
              refError,
              hasRefData,
              refData,
            }) => {
              return (
                <React.Fragment>
                  {refLoading && !hasRefData && <Skeleton />}
                  {!refLoading && hasRefData && (
                    <UserInviteScreen data={refData} />
                  )}
                  {!refLoading && refError && <Redirect to={'/404'} />}
                </React.Fragment>
              )
            }}
          />
        )}
      </React.Fragment>
    )
  }
}
export default ReferralsPage
